import $ from 'jquery';
import { Functions } from '../helpers';

export class Slide {

	constructor( App ) {
		Slide.App      = App;
		Slide.UI       = App.PwnUI;
		Slide.settings = App.settings;
		Slide.options  = {
			'general': {
				element: '.js-pwn-swiper-container',
				instance: {},
				params: {
					pagination          : '.swiper-general-pagination',
					nextButton          : '.swiper-general-button-next',
					prevButton          : '.swiper-general-button-prev',
					paginationClickable : true,
					spaceBetween        : 5,
					slidesPerView       : 1,
					simulateTouch       : false,
					grabCursor          : false,
					loop				: true,
				}
			},
			'two-way-horiz': {
				element: '.js-pwn-swiper-two-way-horiz-container',
				instance: {},
				control: 'two-way-vert',
				params: {
					pagination           : '.swiper-two-way-horiz-pagination',
					nextButton           : '.swiper-two-way-horiz-button-next',
					prevButton           : '.swiper-two-way-horiz-button-prev',
					paginationClickable  : true,
					centeredSlides       : false,
					slidesPerView        : 1,
					// slideToClickedSlide  : true,
					spaceBetween         : 10,
					loop                 : true,
					loopedSlides         : 5,
					loopAdditionalSlides : 5,
					inverse              : true
				}
			},
			'two-way-vert': {
				element: '.js-pwn-swiper-two-way-vert-container',
				instance: {},
				control: 'two-way-horiz',
				params: {
					pagination           : '.swiper-two-way-vert-pagination',
					nextButton           : '.swiper-two-way-vert-button-next',
					prevButton           : '.swiper-two-way-vert-button-prev',
					paginationClickable  : true,
					inverse              : true,
					spaceBetween         : 0,
					centeredSlides       : true,
					slidesPerView        : 5,
					touchRatio           : 0.2,
					slideToClickedSlide  : true,
					loop                 : true,
					loopedSlides         : 5,
					loopAdditionalSlides : 5,
					direction            : 'vertical'
				}
			},
			'latest-articles': {
				element: '.js-pwn-swiper-latest-articles-container',
				instance: {},
				params: {
					pagination          : '.swiper-latest-articles-pagination',
					nextButton          : '.swiper-latest-articles-button-next',
					prevButton          : '.swiper-latest-articles-button-prev',
					paginationClickable : true,
					spaceBetween        : 0,
					slidesPerView       : 3,
					simulateTouch       : false,
					grabCursor          : false,
					loop                : true,
					// autoHeight          : true,
					// loopedSlides        : 4,
					// loopAdditionalSlides: 4,
					breakpoints: {
					    // when window width is <= 640px
					    640: {
							slidesPerView: 1
					    },
					    // when window width is <= 992px
					    992: {
							slidesPerView: 2
					    }
				    }
				}
			},
			'testimonials': {
				element: '.js-pwn-swiper-testimonials-container',
				instance: {},
				params: {
					pagination          : '.swiper-testimonials-pagination',
					nextButton          : '.swiper-testimonials-button-next',
					prevButton          : '.swiper-testimonials-button-prev',
					paginationClickable : true,
					spaceBetween        : 25,
					slidesPerView       : 3,
					simulateTouch       : false,
					grabCursor          : false,
					loop                : true,
					// loopedSlides        : 4,
					// loopAdditionalSlides: 4,
					breakpoints: {
					    // when window width is <= 486px
					    486: {
							slidesPerView: 1
					    },
					    // when window width is <= 992px
					    992: {
							slidesPerView: 2
					    }
				    }
				}
			},
			'related-products': {
				element: '.js-pwn-swiper-related-products-container',
				instance: {},
				params: {
					pagination          : '.swiper-related-products-pagination',
					nextButton          : '.swiper-related-products-button-next',
					prevButton          : '.swiper-related-products-button-prev',
					paginationClickable : true,
					spaceBetween        : 0,
					slidesPerView       : 5,
					simulateTouch       : false,
					grabCursor          : false,
					loop                : false,
					// autoHeight          : true,
					// loopedSlides        : 4,
					// loopAdditionalSlides: 4,
					breakpoints: {
					    // when window width is <= 640px
					    640: {
							slidesPerView: 2
					    },
					    // when window width is <= 992px
					    992: {
							slidesPerView: 3
					    }
				    }
				}
			},
			'background': {
				element: '.js-pwn-swiper-site-slider',
				instance: {},
				params: {
				    grabCursor: true,
					loop: true,
					slidesPerView: 1,
                    autoplay: 3000,
                    effect: 'fade',
				}
			}
		};

		this.initialize();
	};

	initialize() {
		var swipers = Slide.options;

		$.each( Slide.options, ( name, swiper ) => {
			if ( ! $( swiper.element ).length ) {
				return;
			}

			var control = swiper.control;

			swiper.params = $.extend( {}, swiper.params, {
		        onInit: function( swiper ) {
		        	var container = $( swiper.container[0] ),
		        		slides    = $( swiper.slides ).not( '.swiper-slide-duplicate' ).length;

		        	container.addClass( 'swiper-slides-' + swiper.params.slidesPerView );

		        	if ( swiper.params.slideToClickedSlide ) {
		        		container.addClass( 'swiper--is-clicked-slide' );
		        	}

		        	// console.log(swiper.params.loop,'swiper.params.loop');
		        	// console.log(slides,'slides');
		        	// console.log(swiper.params.slidesPerView,'slidesPerView');

		        	// if ( slides <= swiper.params.slidesPerView && swiper.params.loop ) {
		        		// swiper.params.loop = false;
		        	// }

		        	// swiper.update();

					/*if ( $( slide.element ).length ) {

						if ( slide.breakpoints ) {
							$.each( slide.breakpoints, function( width, settings ) {
								if ( Pwn_UI.viewportWidth <= width ) {
									swiper.params.slidesPerView = settings.slidesPerView;
									return;
								}
								else {
									swiper.params.slidesPerView = slide.defaultParms.slidesPerView;
									return;
								}
							} );
						}
					}*/

					Slide.check_slides( swiper );
		        }
			} );

			swipers[ name ].instance = new Swiper( swiper.element, swiper.params );

			// Check if an control exists an then make a link between swiper and control
			if ( control in swipers ) {
				var controlled = swipers[ control ].instance;

				swiper.params = $.extend( swiper.params, {
					control: controlled
				} );

				swipers[ control ].params = $.extend( swipers[ control ].params, {
					control: swiper.instance
				} );
			}
		} );
	};

	static resize() {
		$.each( Slide.slides, ( name, swiper ) => {
			if ( ! $( swiper.element ).length ) {
				return;
			}

			Slide.check_slides( swiper.instance );

			// console.log('on resize');

			/*if ( swiper.breakpoints ) {
				$.each( swiper.breakpoints, function( width, settings ) {
					if ( Pwn_UI.viewportWidth <= width ) {
						Slides.slide[ name ].instance[ name ].params.slidesPerView = settings.slidesPerView;
						return;
					}
					else {
						Slides.slide[ name ].instance[ name ].params.slidesPerView = swiper.defaultParms.slidesPerView;
						return;
					}
					console.log(width, 'width');
				} );
			}*/

			/**
			 * This method includes updateContainerSize, updateSlidesSize,
			 * updateProgress, updatePagination and updateClasses methods.
			 *
			 * @link http://idangero.us/swiper/api/
			 */
			// Slides.slide[ name ].instance.update();
		} );
	};

	static check_slides( swiper ) {
		if ( ! Functions.objectLength( swiper ) ) return;

    	var container       = $( swiper.container[0] ),
			slides          = $( swiper.slides ).not( '.swiper-slide-duplicate' ).length,
			arrowsContainer = container.parent().find( '.swiper-button-prev, .swiper-button-next' );

		if ( container.hasClass( 'js-swiper--not-hide-if-many-slides' ) ) {
			return;
		}

		// swiper.loopedSlides = slides;
		// swiper.loopAdditionalSlides = slides;

		// console.log(swiper);
		// console.log(arrowsContainer);
		// console.log(swiper.loopedSlides, 'loopedSlides');
		// console.log(swiper.loopAdditionalSlides, 'loopAdditionalSlides');
		// console.log(swiper.params.slidesPerView, 'swiper.params.slidesPerView');

		if ( swiper.params.slidesPerView >= slides ) {
			if ( arrowsContainer.length ) {
				arrowsContainer.hide();
			}

			swiper.detachEvents();
		}
	};
}
